import gsap from "gsap";
import { Power2 } from "gsap/gsap-core";
import DocumentBody from "./DocumentBody";

export default class VideoLoading {
  constructor() {
    this.documentBody = new DocumentBody();
    this.documentBody.disableScrollBar();

    gsap.set("#sticky-header", { yPercent: -100 });

    this.logoAnimation();
  }

  logoAnimation() {
    const duration = 0.6;
    const position = "-=0.3";
    const ease = Power2.easeOut;

    const settings = {
      duration,
      ease,
    };

    const animeIn = {
      ...settings,
      fillOpacity: 1,
    };

    const animeOut = {
      ...settings,
      fillOpacity: 0,
    };

    const tl = new gsap.timeline({
      repeat: -1,
      repeatDelay: 1,
      delay: 0.25,
    });

    tl.to(".mantis-logo-line-1", animeIn, position);
    tl.to(".mantis-logo-line-2", animeIn, position);
    tl.to(".mantis-logo-line-3", animeIn, position);
    tl.to(".mantis-logo-line-4", animeIn, position);
    tl.to(".mantis-logo-line-5", animeIn, position);
    tl.to(".mantis-logo-line-6", animeIn, position);

    tl.to(".mantis-logo-line-5", animeOut, position);
    tl.to(".mantis-logo-line-6", animeOut, position);
    tl.to(".mantis-logo-line-2", animeOut, position);
    tl.to(".mantis-logo-line-1", animeOut, position);
    tl.to(".mantis-logo-line-4", animeOut, position);
    tl.to(".mantis-logo-line-3", animeOut, position);
  }

  completed() {
    const loading = document.getElementById("video__loading");
    const tl = new gsap.timeline();
    tl.to(loading, {
      yPercent: -100,
      duration: 1,
      ease: Power2.easeInOut,
      onComplete: () => {
        this.documentBody.enableScrollBar();
        // Remove Loading from DOM tree
        loading.parentNode.removeChild(loading);
      },
    });
    tl.to("#sticky-header", { yPercent: 0, duration: 1, ease: Power2.easeOut });
  }
}
